import { SEASON_TYPE } from "../constants";
import { APP_SCENE } from "../constants/enums";

const initialState = {
  seasonList: [],
  openSeasonId: null,
  voteStatus: "",
  season: null,
};

export function seasonReducer(state = initialState, action) {
  switch (action.type) {
    case SEASON_TYPE.GET_SEASON_LIST_LOADING:
    case SEASON_TYPE.UPDATE_SEASON_LOADING:
      return { ...state, loading: true };

    case SEASON_TYPE.GET_SEASON_LIST_FAILURE:
    case SEASON_TYPE.UPDATE_SEASON_FAILURE:
      return { ...state, loading: false };

    case SEASON_TYPE.GET_SEASON_LIST_SUCCESS:
      return {
        ...state,
        seasonList: [
          ...action.payload.filter(
            (e) => e.category === APP_SCENE && e.deletedAt === null
          ),
        ],
        openSeasonId: action.payload.find(
          (e) => e.status === "open" && e.category === APP_SCENE
        )?.id,
        voteStatus: action.payload.find(
          (e) => e.status === "open" && e.category === APP_SCENE
        )?.voteStatus,
        season: action.payload.find(
          (e) => e.status === "open" && e.category === APP_SCENE
        ),
        loading: false,
      };

    case SEASON_TYPE.UPDATE_SEASON_SUCCESS: {
      const updated = action.payload;
      const seasonList = [
        ...state.seasonList.filter((e) => e.id !== updated.id),
        updated,
      ];

      // Suy lại mùa đang mở theo ĐÚNG quy tắc của GET_SEASON_LIST_SUCCESS.
      // Trước đây case này chỉ sửa `openSeasonId` + `seasonList`, KHÔNG sửa
      // `voteStatus` và `season` -> admin đổi vòng bình chọn, lưu xong mà màn
      // Bình chọn / Kết quả vẫn đọc vòng CŨ cho tới khi tải lại trang.
      const openSeason = seasonList.find(
        (e) => e.status === "open" && e.category === APP_SCENE
      );

      return {
        ...state,
        loading: false,
        seasonList,
        openSeasonId: openSeason?.id ?? updated.id,
        voteStatus: openSeason?.voteStatus ?? state.voteStatus,
        season: openSeason ?? state.season,
      };
    }

    default:
      return state;
  }
}
